import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { determineDeclension } from '@beef/utils';
import { content } from "../../../../constants/tariffTile";
import { Icon } from "../Icon";
import styles from "./styles.module.pcss";
var cn = classNames.bind(styles);
export var NumbersSharing = /*#__PURE__*/memo(function (_ref) {
  var compactParameter = _ref.compactParameter,
    cardType = _ref.cardType;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('sharing__numbers', cardType && "sharing__numbers--".concat(cardType)),
    "data-t-id": "components-NumbersSharing"
  }, (compactParameter === null || compactParameter === void 0 ? void 0 : compactParameter.size) && /*#__PURE__*/React.createElement("div", {
    className: cn('sharing__numbers__content')
  }, /*#__PURE__*/React.createElement(Icon, {
    className: cn('user__add'),
    name: "userAdd"
  }), /*#__PURE__*/React.createElement("div", {
    className: cn('sharing__numbers__size')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size4-m"
  }, content.sharing.plus, compactParameter.size)), /*#__PURE__*/React.createElement("div", {
    className: cn('sharing__numbers__text')
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size5-r-s"
  }, determineDeclension(content.sharing.numbers, compactParameter.size)))));
});